import http from 'kaitaiming-http';
import session from '@/public/session';

http.setHeader('user_name', 'superuser');
http.setRequestInterceptors((config) => {
    config.headers.KSESSIONID = session.getSessionId();
});

export default http;
